import { Link } from "react-router-dom";
import { formatRp, imgUrl } from "@/lib/api";

const StockLine = ({ stock }) => {
  if (stock <= 0) return <span className="text-red-700">Stok habis</span>;
  if (stock <= 5) return <span className="text-amber-700">Sisa {stock}</span>;
  return <span className="text-green-700">Stok {stock}</span>;
};

export const ProductCard = ({ p }) => (
  <Link to={`/produk/${p.id}`} data-testid={`product-card-${p.id}`}
    className="group flex flex-col overflow-hidden rounded-lg border border-stone-200 bg-white hover:border-amber-700/50">
    <div className="relative aspect-square overflow-hidden bg-stone-100">
      <img src={imgUrl(p.images?.[0])} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
      {p.discount_percent > 0 && (
        <span className="absolute left-2 top-2 rounded-full bg-amber-700 px-2 py-0.5 text-xs font-semibold text-white">-{p.discount_percent}%</span>
      )}
    </div>
    <div className="flex flex-1 flex-col gap-1.5 p-3 md:p-4">
      <span className="text-xs text-stone-500">{p.category_name}</span>
      <h3 className="line-clamp-2 text-sm font-medium text-stone-900 md:text-base">{p.name}</h3>
      <div className="mt-auto pt-2">
        {p.discount_percent > 0 && <p className="tnum text-xs text-stone-400 line-through">{formatRp(p.price)}</p>}
        <p className="tnum font-semibold text-amber-800" data-testid={`product-card-price-${p.id}`}>{formatRp(p.final_price)}</p>
        <p className="mt-1 text-xs"><StockLine stock={p.stock} /></p>
      </div>
    </div>
  </Link>
);
